import { render, staticRenderFns } from "./ClinicianDetailsTooltip.vue?vue&type=template&id=4aa2a80d"
import script from "./ClinicianDetailsTooltip.vue?vue&type=script&lang=js"
export * from "./ClinicianDetailsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports